import { useGetListBankAccount } from '../../api/bankAccount';

const DEFAULT_BANK_ACCOUNT_PAGE_SIZE = 10;

export const useBankAccountManagement = (
  companyId: number,
  params: { start: number; end: number; },
  searchName: string,
  enabled: boolean
) => {
  const {
    data = {
      data: [],
      totalCount: 0,
      page: 1,
      pageSize: DEFAULT_BANK_ACCOUNT_PAGE_SIZE,
      totalPages: 0,
    },
    isLoading,
    refetch,
  } = useGetListBankAccount({
    ...params,
    companyId,
    name: searchName,
    enabled,
  });

  const dataListBankAccount = {
    items: data?.data || [],
    total: data?.totalCount || 0,
    page: data?.page || 1,
    pageSize: data?.pageSize || DEFAULT_BANK_ACCOUNT_PAGE_SIZE,
    totalPages: data?.totalPages || 0,
  };

  return { dataListBankAccount, refetch, isLoading };
};

